// The isometric material icon of each game item (design system ResourceIcon), with a plain swatch for
// items that have no drawing yet.
import type { ResourceKind } from '../world/island';
import { h } from './dom';
import { resourceIcon } from './resource-icon';

const KIND: Readonly<Record<string, ResourceKind>> = {
  iron_ore: 'mineral',
  iron_plate: 'hierro',
  gear: 'engranaje',
};

export function itemIcon(item: string, size: number, color = '#ffffff'): HTMLSpanElement {
  const kind = KIND[item];
  if (kind) return resourceIcon(kind, size);
  return h('span', { class: 'item-swatch', 'aria-hidden': 'true', style: `width:${size * 0.7}px;height:${size * 0.7}px;background:${color}` });
}
